module.exports = __webpack_public_path__ + "img/Picture12.ff7b949a.png";